import { Injectable } from "@angular/core";
import { AuditLogService } from "@app/audit-log/services/audit-log.service";
import { EntityInfo, EntityInfoData, EntityInfoHelper } from "@app/entity/model/entityinfo";
import { ClareWSCrudHelperService } from "@app/shared/services/clare-ws-crud-helper.service";
import { DbCrudHelper } from "@app/shared/services/db-crud-helper";
import { map } from "rxjs";

@Injectable()
export class EntityInfoDbService {
    helper = new EntityInfoHelper();
    wsHelper: ClareWSCrudHelperService<EntityInfo, EntityInfoData>;
    constructor(private tsLoggingService: AuditLogService, private crudHelper: DbCrudHelper) {
        this.wsHelper = new ClareWSCrudHelperService(this.tsLoggingService, this.crudHelper, this.helper);
    }

    getAll(entityId: number) {
        return this.wsHelper.retrieve({
            endpoint: "GetEntityEntityinfos",
            data: {
                id: entityId,
            },
        });
    }

    create(entityInfo: EntityInfo, log: any) {
        const { auditLogName, ...logData } = log || {};
        return this.wsHelper
            .create({
                endpoint: "CreateEntityinfo",
                data: entityInfo,
                logData,
                auditLogName,
            })
            .pipe(
                map(entityinfo => {
                    const returnValue = this.helper.fromDbObject(entityinfo);
                    returnValue.type = entityInfo.type; // set the type to what was passed as param since BE response doesn't provide it
                    return { entityinfo: returnValue };
                })
            );
    }

    update(entityInfo: EntityInfo, log: any) {
        const { auditLogName, ...logData } = log || {};
        return this.wsHelper
            .update({
                endpoint: "UpdateEntityinfo",
                data: entityInfo,
                logData,
                auditLogName,
            })
            .pipe(map(_ => ({ entityinfo: entityInfo })));
    }

    delete(entityinfo: EntityInfo, log: any = {}) {
        const { auditLogName, ...logData } = log;
        return this.wsHelper
            .delete({
                endpoint: "DeleteEntityinfo",
                id: entityinfo.id,
                logData,
                auditLogName,
            })
            .pipe(map(_ => ({ entityinfo })));
    }
}
